export const isApiErrorResponse = (ex) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const data = ex?.data;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return data && 'code' in data && 'message' in data;
};
//# sourceMappingURL=errors.js.map